<template>

    <div class="availtable datatable text-left">

        <p class="pt-0 px-0">
            <b-row>
                <b-col>
                    <b-alert :show="true" variant="secondary">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                            <b-col>
                                <span class="h6"> Select the spreadsheet to analyse, we will check the sheet and
                                    validate the
                                    ticket numbers to determine if refunds can be processed.
                                </span></b-col></b-row>
                    </b-alert>
                </b-col>
            </b-row>

            <b-card-body class="py-0 px-0">
                <div>
                    <b-row>
                        <b-col cols="12" sm="6" md="6" xl="6">
                            <b-form-group label="Click x to remove or browse for document upload..." label-size="sm">
                                <b-input-group>

                                    <b-input-group-prepend>
                                        <b-button size="sm" title="delete" variant="outline-danger"
                                            @click="fileUpload_clear">
                                            <i class="fa fa-remove"></i>
                                        </b-button>
                                    </b-input-group-prepend>
                                    <b-form-file class="ml-1 z-0" id="file-small" size="sm" ref="file-input"
                                        :multiple="false" no-drop @change="fileUpload_selected" :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                            " :disabled="fileUpload ? true : false"></b-form-file>
                                    <b-input-group-append>
                                        <b-button class="ml-1" size="sm" title="view file" variant="outline-primary"
                                            @click="fileUpload_view" :disabled="!fileUpload">
                                            <i class="fa fa-download"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="6" md="4" xl="3">
                            <b-row>
                                <b-col>
                                    <b-form-group label="Type" label-for="type" label-cols="12">
                                        <treeselect instanceId="type" type="number" v-model="item.type"
                                            :clearable="true" :options="type_options" :disabled="true">
                                        </treeselect>
                                    </b-form-group></b-col>
                                <b-col>
                                    <b-form-group label="Size" label-for="size" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.size" placeholder="Enter size"
                                                size="sm" :disabled="true"></b-form-input>

                                        </b-input-group> </b-form-group></b-col>

                            </b-row>
                        </b-col>
                        <b-col cols="12" sm="6" md="4" xl="3">
                            <b-form-group label="Source Filter" label-for="sourcetype" label-cols="12">
                                <b-form-input v-model="sourcetype" size="sm" :disabled="true"
                                    placeholder="Not detected">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">

                    <r-table :refid="refund.refid" :busy="refund.busy" :icon="refund.icon" :showtoolbar="true"
                        :showsheets="true" :showpages="false" :showfab="false" :tools="refund.tools"
                        :toolbar="refund.toolbar" :fields="refund.fields" :items="refund.items" :dirty="refund.dirty"
                        @click="refund_click" @select="refund_select" />

                </b-overlay>

                <b-row class="px-0 mt-3">
                    <b-col>
                        <b-alert :show="message_sheet != null" variant="danger">
                            <b-row no-gutters align-v="center">
                                <b-col cols="auto" class="mr-3">
                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                <b-col>
                                    <span v-html="message_sheet"></span></b-col></b-row>
                        </b-alert></b-col>
                </b-row>
            </b-card-body>
        </p>

        <b-row class="px-0">
            <b-col>
                <b-alert :show="errormessage ? true : false" variant="danger">
                    <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                            <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                        <b-col>
                            {{ errormessage }}
                        </b-col></b-row>
                </b-alert></b-col>
        </b-row>

        <b-row class="nopadding mt-0 mx-0 border-none" no-gutters>
            <b-col cols="auto" class="text-left">
                <b-button squared size="sm" variant="primary" @click="saveit()" :disabled="posted"
                    v-if="(user.permissions.includes('tickets.save') || user.permissions.includes('boughtledger.save'))">
                    <i class="fa fa-check"></i>
                    Post It
                </b-button>
            </b-col>
            <b-col class="text-left ml-2 mt-1">
                <div v-if="busy">
                    <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                    <span v-html="message"></span>
                </div>
            </b-col>

        </b-row>


    </div>

</template>

<script>
import gql from "graphql-tag";

export default {
    name: "BankingsRefund",
    async mounted() {
        console.log("BankingsRefund mounted");

        await this.accessdenied();

        this.state = null
        this.activesheet.fields = []
        this.activesheet.items = []
        this.fileUpload_clear()

    },

    data() {
        return {
            header: {
                title: "Banking Refund",
                icon: "fa fa-check-square-o text-primary",
                debounce: 500,
            },
            file: {
                name: 0,
                size: 0
            },
            sourcetype: 'REFUND',
            upload: null,
            type_options: [
                { id: 0, label: "File" },
                { id: 1, label: "File folder" },
            ],

            errormessage: "",
            headerShow: false,
            showback: true,

            busy: false,
            account_id: null,
            action_tab: 0,
            state: null,
            posted: true,
            readonly: false,
            message: null,
            message_sheet: null,
            textsize: "",


            item: {
                id: null,
                type: "debit",
                accountname: "New Account",
                bankname: null,
                open_at: this.$moment().utc(true).valueOf().toString(),
                currency: "GBP",
                open_balance: "0.00",
                isactive: "true",
                isdashboard: "false"
            },

            refund: {
                title: "Refund Sheet Import",
                icon: "fa fa-cloud-upload",
                debounce: 500,
                busy: false,
                dirty: false,
                page: 1,
                tools: "go,export,copy,textsize,error,missing,credited,pending,sheet_1",
                toolbar: [],
                fields: [],
                items: [],
                loaded: []
            },

        };
    },
    watch: {
        "$store.state.selection": {
            immediate: true,
            async handler(newVal, oldVal) {
                console.log('$store.state.selection', newVal)
                this.selection = [this.$store.state.selection[0]]
                this.headerShow = this.$route.query.showheader == 'true' ? true : false
                this.action_tab = 0
            }
        },
        fileUpload: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                this.state = null
                this.activesheet.fields = []
                this.activesheet.items = []
                this.item.type = 0;
                if (newVal) {
                    this.item.name = newVal.name;
                    this.item.size = newVal.size;
                    await this.preview(JSON.stringify(newVal));
                } else {
                    this.item.name = null;
                    this.item.size = 0;
                    this.message_sheet = null
                }
            },
        },
        "item.name": {
            async handler(newVal, oldVal) {
                if (this.fileUpload) {
                    this.fileUpload.name = newVal;
                }
            },
        },

        action_tab: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.errormessage = ""
                }
            }
        }
    },
    computed: {
        readonly() {
            return true;
        },

        activesheet() {
            if (this.sourcetype == "REFUND") {
                return this.refund
            } else if (this.sourcetype == "EMD") {
                return this.emd
            } else {
                return this.other
            }
        },

        postit_visible() {
            if (this.user.permissions.includes('bankings.save') && this.action_tab != 0) {
                return true
            } else {
                return false
            }
        },
        postit_enabled() {
            if (this.user.permissions.includes('bankings.save')) {
                return true
            } else {
                return false
            }
        },


    },
    methods: {
        accessdenied() {

            this.bankingslines.denied = [];
            if (this.user.permissions.includes("systems.development")) {
                this.bankingsimports.tools = "go,filter,import,download,rename,deleteconfirm,redo,reorder,saveas"
            }
        },

        async preview(data) {
            this.activesheet.busy = true;
            this.message_sheet = null
            this.message = null

            let variables = {
                data: JSON.stringify(this.fileUpload),
                state: this.state,
                type: this.sourcetype
            };

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query file_preview($data: String, $state: String, $type: String) {
                            file_preview(data: $data, state: $state, type: $type) {
                                sheet
                                fields
                                items
                                type
                            }
                        }
                    `,
                    variables,
                });

                if (response.data.file_preview[0].type == this.sourcetype) {
                    this.sheets = response.data.file_preview
                    this.activesheet.fields = JSON.parse(response.data.file_preview[0].fields);
                    this.activesheet.items = JSON.parse(response.data.file_preview[0].items);
                    this.activesheet.loaded = this.activesheet.items
                    let find = this.activesheet.toolbar.find((o) => o.action == "sheet_1");
                    if (find) {
                        find.label = response.data.file_preview[0].sheet
                    }
                    this.posted = false

                } else {
                    this.message_sheet = "Sheet could not be loaded, cannot load a sheet of type '" + response.data.file_preview[0].type + "' for '" + this.sourcetype + "' source processing.";
                }

            } catch (error) {
                console.log(error);
            }
            this.activesheet.busy = false;

        },

        async refund_click(a, ss) {
            console.log("refund_click", a, ss);

            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "go":
                    this.component = null;
                    this.state = null
                    this.preview();
                    break;
                case "credited":
                case "pending":
                case "missing":
                case "error":
                    this.state = a
                    this.message_sheet = null
                    this.activesheet.items = this.activesheet.loaded.filter(o => o.state == a.charAt(0).toUpperCase() + a.slice(1))
                    if (this.activesheet.items.length == 0) {
                        this.message_sheet = "Hmmm, looks like there are no rows marked with a state of '" + a + "''"
                    }
                    break;
            }
        },

        async refund_select(ss, tools) {
            console.log("refund_select", ss);

            let state = this.refund;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "textsize",
                    "credited",
                    "pending",
                    "missing",
                    "hold",
                    "error",
                    "export",
                    "download",
                    "copy",
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },

        resetModal() {
            this.name = ''
            this.nameState = null
        },

        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },

        async handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return
            }
            // Push the name to submitted names
            // this.submittedNames.push(this.name)
            await this.bankingsimports_import()

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('import-file')
            })
        },

        back() {
            if (this.headerShow) {
                this.$router.back(-1)
            } else {
                this.$emit('discard')
            }
        },
    },
};
</script>

<style>
.courier .tooltip-inner {
    /* Removes the default max-width */
    max-width: 560px;
    font-family: 'Courier New', Courier, monospace;
}
</style>